<template>
  <div style="position:absolute;top:0;left:0;right:0;bottom:0;" class="layout-column">
    <div class="layout-column flex ma-2"
         style="border-radius:4px;position:relative;"
         v-bind:style="{background: compColor.contentFrame}">
      <div v-bind:style="{'z-index': '4'}" class="layout-row layout-align-center-center pa-1">
        <div class="layout-row">
          <lx-btn small classes="mx-1" :disabled="false"
                  @click="getDataForTable()"
                  icon="refresh" tooltip="Ansicht aktualisieren" label="Aktualisieren"
                  :hide-label="true"></lx-btn>
        </div>

        <div class="flex layout-row layout-align-center-center pt-2">
          <label style="font-size: 16px;" class="mx-3" :style="{color: compColor.primeColor}" :dark="compColor.isInDarkMode">Meldungen im Zeitraum von:</label>

          <validation-provider tag="div"
                               ref="startDate"
                               name="startDate"
                               :rules="{german_date:true, date_not_in_future: true, date_must_be_lesser_than: endDate}"
                               v-slot="{ errors }">
            <lx-datepicker
              :color="compColor.textInput"
              :dark="compColor.isInDarkMode"
              name="startDate"
              :hide-details="!errors || errors.length <= 0"
              class="ml-3"
              dense
              :error="errors[0]"
              v-model="startDate">
            </lx-datepicker>
          </validation-provider>

          <label style="font-size: 16px;" class="mx-3" :style="{color: compColor.primeColor}">bis:</label>

          <validation-provider tag="div"
                               ref="endDate"
                               name="endDate"
                               :rules="{german_date:true, date_must_be_greater_than: startDate, date_not_in_future: true}"
                               v-slot="{ errors }">
            <lx-datepicker
              :color="compColor.textInput"
              :dark="compColor.isInDarkMode"
              name="endDate"
              dense
              :hide-details="!errors || errors.length <= 0"
              :error="errors[0]"
              v-model="endDate">
            </lx-datepicker>
          </validation-provider>

          <div class="layout-row ml-5" style="font-size: 16px;">
            <span :style="{color: compColor.primeColor}"
                  :dark="compColor.isInDarkMode">{{ !startDate && !endDate ? $t('STATISTICS.OVERALL') : $t('STATISTICS.TIME_PERIOD') }}&nbsp;</span>
            <span v-show="reports"
                  v-html="setHeaderMessage()"
                  :style="{color: compColor.primeColor}"
                  :dark="compColor.isInDarkMode"></span>
            <span :style="{color: compColor.primeColor}"
                  :dark="compColor.isInDarkMode"
                  v-show="!reports">{{ $t('STATISTICS.TEXT_PART_EMPTY') }}</span>
          </div>
        </div>
      </div>

      <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

      <div class="flex layout-column lx-delivery-background pa-1" style="overflow-y: hidden">

        <div class="elevation-3 flex layout-column pa-1" style="border-radius: 6px;" :style="{'background': compColor.lxExpansion.background}">
          <div style="border-radius: 6px;border: 1px solid rgba(0,0,0,0.1);" class="flex layout-column" ref="ReportsList">
            <lx-data-table
              tableName="ReportsList"
              v-model="tableObj.selection"
              :items="items"
              :headers="tableObj.headers"
              :loading="tableObj.loading"
              :preventRowClick="true"
              :hideContextFilter="true"
              :tableOptions="tableObj.options"
              @changeOptions="changeTableOptions">

              <template v-slot:masterdetail="{ item }">
                <div class="py-4 px-6" :style="{'max-width': windowW + 'px !important'}">
                  <report-details-list :reportId="item.id"></report-details-list>
                </div>
              </template>

              <template v-slot:cellrenderer="{ value }">
                <!-- date-time renderer -->
                <span v-if="value.f.renderer === 'datetime'">{{ value.i[value.f.value] | formatDate('DD.MM.YYYY HH:mm') }}</span>

                <!-- checkbox renderer -->
                <div v-if="value.f.renderer === 'checkbox'" style="height:35px;" class="layout-column layout-align-center-center">
                  <v-simple-checkbox
                    :dark="compColor.isInDarkMode"
                    :color="compColor.primeColor"
                    disabled
                    style="cursor: pointer;"
                    @click="changeReportedState(value.i)"
                    v-model="value.i[value.f.value]"></v-simple-checkbox>
                </div>

                <!-- icon renderer -->
                <div v-if="value.f.renderer === 'icon'" style="height:35px;cursor:pointer;" class="layout-column layout-align-center-center">
                  <v-icon
                    :class="compColor.isInDarkMode ? compColor.primeHighlightClass : compColor.primeClass"
                    size="24"
                    @click="startDownloadFile(value.i)"
                    style="cursor: pointer;">
                    get_app
                  </v-icon>
                </div>
              </template>
            </lx-data-table>
          </div>
        </div>
      </div>

      <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

      <div class="layout-row pa-0">
        <lx-pagination :page-name="'ReportsList'"
                       :page-options="pagingOptions"
                       :page-change="getDataForTable">
        </lx-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import LxPagination from '../../components/lx_pagination/LxPagination'
import ReportDetailsList from './ReportDetailsList'

export default {
  name: 'ReportsList',
  data () {
    return {
      windowW: window.innerWidth,
      tableObj: {
        loading: false, // benutzt während des GetData, um eine Ladeanimation einzublenden
        options: {
          sortBy: ['creation_date'],
          sortDesc: [false],
          getClassForItem: (row) => {
            if (row.isExpanded) {
              return 'row-bold'
            }
            return ''
          }
        },
        selection: null,
        headers: [
          {
            text: 'Erstellt',
            value: 'creation_date',
            width: '200px',
            renderer: 'datetime',
            sortable: true
          },
          {
            text: 'Anzahl Patienten',
            value: 'patients',
            width: '200px',
            sortable: true
          },
          {
            text: 'Anzahl Meldeformulare',
            value: 'forms',
            width: '200px',
            sortable: true
          },
          {
            text: 'Download',
            value: 'id',
            width: '150px',
            renderer: 'icon'
          },
          {
            text: 'An Krebsregister gemeldet',
            value: 'is_reported',
            width: '200px',
            renderer: 'checkbox'
          },
          {
            text: '',
            value: 'data-table-expand',
            sticky: 'right',
            width: '50px'
          }
        ]
      },
      items: [],
      pagingOptions: {
        limit: 50,
        skip: 0,
        count: 0
      },
      startDate: null,
      endDate: null,
      reports: null,
      patients: null,
      reportedForms: null
    }
  },
  components: {
    ReportDetailsList,
    LxPagination
  },
  created () {
    this.getDataForTable()
  },
  mounted () {
    const tC = this.$refs.ReportsList
    this.windowW = tC.clientWidth - 20

    window.addEventListener('resize',() => {
      this.windowW = tC.clientWidth - 20
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', null)
  },
  methods: {
    /**
     * Mark report in list as sent or not
     */
    changeReportedState (item) {
      if (this.tableObj.loading) return
      this.tableObj.loading = true

      this.$http.post('/reports/setIsReported', { id: item.id, is_reported: !item.is_reported })
        .catch(this.NotifyError)
        .finally(() => {
          this.tableObj.loading = false

          this.getDataForTable()
        })
    },

    /**
     * Download selected report file
     */
    startDownloadFile (item) {
      this.$http.getAsBlob('/reports/getReportFile/' + item.id)
        .then(res => {
          if (res.data && res.data instanceof Blob) {
            let objectURL = URL.createObjectURL(res.data)
            const hiddenElement = document.createElement('a')
            hiddenElement.style.display = 'none'
            hiddenElement.href = objectURL
            hiddenElement.download = 'Meldung_' + this.$options.filters['formatDate'](item.creation_date, 'YYYY-MM-DD_HHmm') + '.xml'
            document.body.appendChild(hiddenElement)
            hiddenElement.click()
            document.body.removeChild(hiddenElement)

            setTimeout(() => {
              // For Firefox it is necessary to delay revoking the ObjectURL
              URL.revokeObjectURL(objectURL)
            }, 100);
          }
        })
        .catch(this.NotifyError)
    },

    /**
     * Localize information to count of reports and their content
     */
    setHeaderMessage () {
      const activity = this.reports > 1 ? this.$t('STATISTICS.WAS_MULTI') : this.$t('STATISTICS.WAS_SINGLE')
      const report = this.reports > 1 ? this.$t('STATISTICS.REPORT_MULTI') : this.$t('STATISTICS.REPORT_SINGLE')
      const forms = this.reportedForms > 1 ? this.$t('STATISTICS.FORM_MULTI') : this.$t('STATISTICS.FORM_SINGLE')

      return this.$t('STATISTICS.TEXT_PART', { countReports: this.reports, countPatients: this.patients, countForms: this.reportedForms, activity: activity, report: report, forms: forms })
    },

    /**
     * React on changes of options in lx-data-table, set table-options in component and call getDataForTable
     */
    changeTableOptions (value) {
      if (value) {
        this.tableObj.options = value
      }
      this.getDataForTable()
    },

    /**
     * Get all reports of physician from db
     */
    getDataForTable (options) {
      // prevent getData, if start date or end date are invalid e.g. after tab change
      if (this.startDate && this.$refs['startDate']?.flags && this.$refs['startDate']?.flags.invalid || this.endDate && this.$refs['endDate']?.flags && this.$refs['endDate']?.flags.invalid) return

      if (this.tableObj.loading) return
      this.tableObj.loading = true

      this.reports = null
      this.patients = null
      this.reportedForms = null

      if (options && typeof options.skip === 'number') {
        this.pagingOptions.skip = options.skip
      }
      if (options && options.limit) {
        this.pagingOptions.limit = options.limit
      }

      let opts = {
        skip: this.pagingOptions.skip,
        limit: this.pagingOptions.limit
      }

      if (this.tableObj.options && this.tableObj.options.sortBy && this.tableObj.options.sortBy.length > 0) {
        opts.sort = {}
        opts.sort[this.tableObj.options.sortBy[0]] = this.tableObj.options.sortDesc[0] ? -1 : 1
      }

      let query = {}

      if (this.startDate) {
        query.startDate = this.startDate
      }

      if (this.endDate) {
        query.endDate = this.endDate
      }

      this.$http.get('/reports/getOverview?config={"opts":' + JSON.stringify(opts) + ', "query": ' + JSON.stringify(query) + '}')
        .then(res => {
          if (res.data) {
            this.items = []
            this.reports = res.data.count || 0
            this.patients = res.data.patients || 0
            this.reportedForms = res.data.forms || 0
            this.pagingOptions.count = res.data.count || 0

            if (Array.isArray(res.data.items)) {
              this.items = res.data.items
            }
          }
        })
        .catch(this.NotifyError)
        .finally(() => {
          this.tableObj.loading = false
        })
    }
  },
  computed: {
    datesHaveChanged () {
      // initialize watchGroup with two props, for better possibility to compare join elements to string
      return [this.startDate, this.endDate].join()
    }
  },
  watch: {
    '$route' (to) {
      if (to.name === 'ReportsList') {
        // reload table content
        this.getDataForTable()
      }
    },
    datesHaveChanged (newValue, oldValue) {
      // give validation time to validate and set correct valid-flag
      setTimeout(() => {
        if (newValue !== oldValue) {
          this.getDataForTable()
        }
      }, 0)
    }
  }
}
</script>
